import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link, useSearchParams } from "react-router-dom";
import { Edit, PlusCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useGetClaimsQuery } from "AppQuries/claim/claim-management";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import Select from "react-select";
import ReportTools from "Components/UI/ReportTools";
import { hasPermission } from "core/Operations/checkPermission";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const { RangePicker } = DatePicker;

const statusOptions = [
  { value: "All", label: "All" },
  { value: 0, label: "Pending" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
];

const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const ClaimList = () => {
  const userData = useSelector(loggedInUser);
  const [employeeCode, setEmployeeCode] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  // const [filterDate, setFilterDate] = useState({
  //   fromDate:
  //     searchParams.get("fromDate") ||
  //     format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
  //   toDate:
  //     searchParams.get("toDate") ||
  //     format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
  // });

  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    departmentCode: 0,
    leaveCode: 0,
    status: searchParams.get("status") || "All",
    fromDate:
      searchParams.get("fromDate") ||
      format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate:
      searchParams.get("toDate") ||
      format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });

  // const permissions =  useSelector(selectUserPermissions) || [];
  const permissions = userData?.permissions;

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getClaimData,
  } = useGetClaimsQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      employee: employeeCode,
      fromDate: queryParams?.fromDate,
      toDate: queryParams?.toDate,
      status: queryParams?.status,
    },
    {
      enabled: !!userData.companyCode,
    },
  );

  const ClaimData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      sorter: (a, b) => a.uniqueId.length - b.uniqueId.length,
    },

    {
      title: "Employee",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },

    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },
    {
      title: "Claim Amount",
      dataIndex: "claimAmount",
      sorter: (a, b) => a.claimAmount.length - b.claimAmount.length,
    },

    {
      title: "Claim From Date",
      dataIndex: "claimFromDate",
      sorter: (a, b) => a.claimFromDate.length - b.claimFromDate.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Claim To Date",
      dataIndex: "claimToDate",
      sorter: (a, b) => a.claimToDate.length - b.claimToDate.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    // hasPermission(
    //   permissions,
    //   "Claims Processing",
    //   "Manage Claims",
    //   "haveEdit"
    // ) &&
    {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.claim_processing}
            accessCode={accessCodes.claim_manage}
            accessType="haveEdit"
          >
            <Link
              className="me-3"
              to={`${all_routes.claim}${all_routes.claim_edit}/${record.code}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
          {/* <Can accessModule={accessCodes.claim_processing} accessCode={accessCodes.claim_manage} accessType="haveDelete">
            <Link className="confirm-text" to="#" onClick={confirmText}>
              <img src={DeleteIcon} alt="img" />
            </Link>
          </Can> */}
        </div>
      ),
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ClaimData,
    searchColumns,
  );

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Claims</h4>
                <h6>Manage your claims</h6>
              </div>
            </div>

            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Claim Report ${queryParams.fromDate} - ${queryParams.toDate}`}
              pdfTheme="striped"
              refresh={getClaimData}
            />
            <div className="page-btn">
              <Can
                accessModule={accessCodes.claim_processing}
                accessCode={accessCodes.claim_manage}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add Multiple Claims</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.claim}${all_routes.claim_add_multiple}`}
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Add Claims
                  </Link>
                </OverlayTrigger>
              </Can>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label">
                                Start Date – End Date
                              </label>
                              <RangePicker
                                // disabledDate={DisabledDate}
                                className="form-control"
                                style={{ display: "flex" }}
                                onChange={(date, dateFormat) => {
                                  updateQueryParams("fromDate", dateFormat[0]);
                                  updateQueryParams("toDate", dateFormat[1]);
                                }}
                                defaultValue={[
                                  dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                                  dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                                ]}
                                format="YYYY-MM-DD"
                                allowClear={false}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label">Employee</label>
                              <Select
                                className="select"
                                options={employeeOptions}
                                placeholder="Select Employee"
                                value={
                                  employeeOptions.find(
                                    (option) =>
                                      option.value === queryParams.employeeCode,
                                  ) || ""
                                }
                                onChange={(e) => {
                                  updateQueryParams(
                                    "employeeCode",
                                    e?.value || 0,
                                  );
                                }}
                                isClearable
                              />
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <label className="form-label">Status</label>
                              <Select
                                className="select"
                                options={statusOptions}
                                placeholder="Status"
                                value={statusOptions.find(
                                  (option) =>
                                    option.value === queryParams.status,
                                )}
                                onChange={(e) => {
                                  updateQueryParams(
                                    "status",
                                    e?.value || "All",
                                  );
                                }}
                                isClearable
                                styles={{
                                  // control: (baseStyles, state) => ({
                                  //   ...baseStyles,
                                  //   width: "200px",
                                  // }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999999999,
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label className="form-label">&nbsp;</label>
                              <Link
                                className="btn btn-filters ms-auto"
                                onClick={getClaimData}
                                type="button"
                              >
                                <i
                                  data-feather="search"
                                  className="feather-search"
                                />
                                {isFetching ? (
                                  <>
                                    <i className="fas fa-spinner fa-spin me-2"></i>
                                    Loading...
                                  </>
                                ) : (
                                  <>Filter</>
                                )}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimList;
